import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const ShareButton = ({ title, text, url, className = '' }) => {
  const [copied, setCopied] = useState(false);

  const share = async (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();

    const shareUrl = url || window.location.href;
    try {
      if (navigator.share) {
        await navigator.share({ title, text, url: shareUrl });
        return;
      }

      await navigator.clipboard.writeText([text, shareUrl].filter(Boolean).join('\n'));
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch (error) {
      if (error?.name !== 'AbortError') {
        alert('Der Link konnte nicht geteilt werden.');
      }
    }
  };

  return (
    <button
      type="button"
      onClick={share}
      className={`inline-flex items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-bold text-gray-700 hover:bg-gray-50 ${className}`}
    >
      <SafeIcon icon={copied ? FiIcons.FiCheck : FiIcons.FiShare2} />
      {copied ? 'Link kopiert' : 'Teilen'}
    </button>
  );
};

export default ShareButton;
